import React from 'react'

const Titulos = (props) => {
    const { bold, italic, Tag = 'h1', justify, color = '#000000' } = props.styles
    return (
        <Tag
            className={justify === 'left' ? 'text-left' : justify === 'center' ? 'text-center' : justify === 'right' ? 'text-right' : null}
            style={{
                fontWeight: bold && 'bold',
                fontStyle: italic && 'italic',
                color
            }}
        >
            {props.styles.textoTitulo ? props.styles.textoTitulo : 'Titulo'}
        </Tag>

    )
}

export default Titulos